<template>
  <div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" v-if="!isCoverLetterDefault">
        <a
          :class="'nav-link ' + (!isCoverLetterDefault ? ' active' : '')"
          id="cover-letter-tab"
          data-toggle="tab"
          data-target="#cover_letter"
          role="tab"
          aria-controls="cover_letter"
          aria-selected="false"
          >Notes</a
        >
      </li>
      <li class="nav-item">
        <a
          :class="'nav-link' + (isCoverLetterDefault ? ' active' : '')"
          id="rfq-tab"
          data-toggle="tab"
          data-target="#rfq"
          role="tab"
          aria-controls="rfq"
          aria-selected="true"
          >RFQ Details</a
        >
      </li>
      <li class="nav-item" v-if="isCoverLetterDefault">
        <a
          class="nav-link"
          id="cover-letter-tab"
          data-toggle="tab"
          data-target="#cover_letter"
          role="tab"
          aria-controls="cover_letter"
          aria-selected="false"
          >Notes</a
        >
      </li>
      <li>
        <a
          class="nav-link"
          id="files-tab"
          data-toggle="tab"
          data-target="#files"
          role="tab"
          aria-controls="files"
          aria-selected="false"
          >Attachments</a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        :class="'tab-pane fade show' + (isCoverLetterDefault ? ' active' : '')"
        id="rfq"
        role="tabpanel"
        aria-labelledby="rfq-tab"
      >
        <h1 class="bd-title pageTitle" id="content">
          RFQ
          <small v-if="rfq">{{ rfq.label }}</small>
          <b-button
            variant="success"
            v-on:click="exportRfq"
            v-b-tooltip.hover.v-secondary
            title="Export RFQ into PDF Format"
            class="pull-right"
          >
            Export RFQ
          </b-button>
          <small v-if="rfq" class="pull-right" style="padding-right: 10px">
            CAGE: {{ rfq.receiving_cage_code }}
          </small>
          <b-overlay :show="showLoadingSpinner" no-wrap></b-overlay>
        </h1>

        <div class="form">
          <rfq-form
            v-on="$listeners"
            v-bind:request="rfq"
            v-bind:response="rfq_response"
            v-on:submit="onSubmit"
            v-bind:loading="loading"
          />
        </div>
        <confirmation-dialog v-model="confirmation" v-on:ok="onConfirm">
          <div>
            <quote-read v-bind:response="rfq_response" v-bind:hideEdit="true" />
          </div>
        </confirmation-dialog>
      </div>
      <div
        v-if="rfq && rfq.cover_letter && rfq.cover_letter !== 'null' && rfq.cover_letter !== 'undefined'"
        :class="'tab-pane fade' + (!isCoverLetterDefault ? ' show active' : '')"
        id="cover_letter"
        role="tabpanel"
        aria-labelledby="cover-letter-tab"
        v-html="rfq.cover_letter"
      ></div>
    <div
      v-else
        class="tab-pane fade"
        id="cover_letter"
        role="tabpanel"
        aria-labelledby="cover-letter-tab"
      >No cover letter</div>      
      <div
        class="tab-pane fade"
        id="files"
        role="tabpanel"
        aria-labelledby="files-tab"
      >
        <div class="upload-container mb-3">
          <input
            type="file"
            id="fileInput"
            multiple
            @change="handleFileAdd"
            class="file-input"
          />
          <button v-on:click="uploadFiles" class="upload-button">Upload</button>
        </div>
        <!-- list attachments -->
        <b-card>
          <b-form-row>
            <b-col cols="12">
              <b-table
                striped
                hover
                :items="attachments"
                :fields="attachmentFields"
              >
                <template v-slot:cell(Filename)="data">
                  <b-link v-on:click="downloadFile(data)">{{
                    data.item.Filename
                  }}</b-link>
                </template>
              </b-table>
            </b-col>
          </b-form-row>
        </b-card>
      </div>
    </div>
  </div>
</template>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;
}

.file-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.upload-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.upload-button:hover {
  background-color: #0056b3;
}
</style>
<script>
import RfqForm from "@/components/rfqs/Form";
import ConfirmationDialog from "@/components/common/ConfirmationDialog";
import QuoteRead from "@/components/quotes/Read";
import { datadogLogs } from "@datadog/browser-logs";
import { getInstance } from "../../auth";
import "bootstrap";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

const PortalApi = require("@brightoncromwell/portal-api");
const rfqsApiInstance = new PortalApi.RfqsApi();
let defaultClient = PortalApi.ApiClient.instance;

export default {
  name: "rfq",
  metaInfo: {
    title: "Rfq",
  },
  components: {
    "rfq-form": RfqForm,
    "confirmation-dialog": ConfirmationDialog,
    "quote-read": QuoteRead,
  },
  data() {
    return {
      rfq: null,
      rfq_response: null,
      loading: false,
      confirmation: false,
      showLoadingSpinner: false,
      files: [],
      attachments: [],
      attachmentFields: ["Filename", "Date"],
    };
  },
  computed: {
    isCoverLetterDefault: function () {
      if (this.rfq && this.rfq.cover_letter == "Hello,<br/><br/>Please provide pricing on the attached as soon as possible.<br/><br/>Please also make sure to include the following information:<br/>Unit Weight<br/>Unit Dimensions<br/>Mfr C of C Availability<br/>Country of Origin<br/><br/>Best Regards") {
        return true;
      }
      return false;
    }
  },
  methods: {
    downloadFile: async function (file_data) {
      const token = await this.getToken();

      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;

      let company_id = parseInt(this.$route.params.company_id); // Number |
      let file_id = parseInt(file_data.item.attachment_id); // Number |

      rfqsApiInstance.rfqsCompanyCompanyIdFilesFileIdGet(
        company_id,
        file_id,
        (error, data, response) => {
          if (error) {
            console.error(error);
          } else {
            console.log(data);
            let byteArray = this.base64ToArrayBuffer(data);
            this.saveByteArray(file_data.item.Filename, byteArray);
          }
        }
      );
    },

    async getAttachments(relatedObjectId) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;
      let apiInstance = new PortalApi.AttachmentsApi();

      apiInstance.attachmentsRelatedObjectIdGet(
        relatedObjectId,
        (error, data, response) => {
          if (error) {
            console.error(error);
          } else {
            console.log("data", data);
            this.attachments = data;
            this.attachments = data?.map((attachment) => ({
              Filename: attachment.filename,
              Date: new Date(attachment.createdTs).toLocaleDateString(),
              attachment_id: attachment.attachmentId,
            }));
          }
        }
      );
    },

    async uploadFiles() {
      await Promise.all(this.files.map(file => this.uploadFile(this.rfq.label, file)));
      this.getAttachments(this.rfq.label);
      alert("Successfully uploaded files");
    },

    async handleFileAdd(file) {
      console.log(this.rfq);
      console.log(this.file);
      this.files = Array.from(event.target.files);
    },

    async uploadFile(relatedObjectId, file) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;
      let apiInstance = new PortalApi.AttachmentsApi();
      let opts = {
        file: file,
      };
      apiInstance.attachmentsUploadRelatedObjectIdPost(
        relatedObjectId,
        opts,
        (error, data, response) => {
          if (error) {
            console.error(error);
          } else {
            console.log("API called successfully. Returned data: " + data);
          }
        }
      );
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    saveByteArray(fileName, byte) {
      console.log(byte);
      var blob = new Blob([byte]);
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    createResponse: function (rfq) {
      console.log("rfq", rfq);
      let response = {
        fob: rfq.fob || "",
        ref_no: rfq.ref_no,
        expiration_ts: rfq.expiration_ts,
        cover_letter: rfq.cover_letter,
        comments: rfq.comments,
        lines: [],
        additional_costs: [],
      };
      rfq.lines.forEach((rfq_line) => {
        let response_line = {
          id: rfq_line.id,
          nsn: rfq_line.nsn,
          part_number: null,
          description: rfq_line.description,
          no_quote_classification: rfq_line.no_quote_classification || null,
          no_quote_other_reason: rfq_line.no_quote_other_reason || null,
          coo: rfq_line.coo || "",
          weight_per_uom: rfq_line.weight_per_uom,
          minimum_order_quantity: rfq_line.minimum_order_quantity,
          will_advise_dt: rfq_line.will_advise_dt,
          quantities: [],
          additional_costs: [],
          disposition: "",
          alternate_nsn: {
            name: null,
            is_form_fit_function_match: null,
            description: null,
          },
          alternate_part_number: {
            name: null,
            is_form_fit_function_match: null,
            description: null,
          },
        };

        if(response_line.no_quote_classification !== 'Other') {
          response_line.no_quote_other_reason = null;
        }

        rfq_line.quantities.forEach((rfq_line_quantity) => {
          let response_line_quantity = {
            qty: rfq_line_quantity.qty,
            uom: rfq_line_quantity.uom,
            lead_time: rfq_line_quantity.lead_time,
            cost: rfq_line_quantity.cost,
            condition: rfq_line_quantity.condition,
            custom_fields: {},
            rfq_line_quantity_id: rfq_line_quantity.rfq_line_quantity_id,
            no_quote: rfq_line_quantity.no_quote,
          };

          rfq_line.custom_fields.forEach((rfq_line_custom_fields) => {
            response_line_quantity.custom_fields[rfq_line_custom_fields] =
              rfq_line_quantity[rfq_line_custom_fields] || "";
          });

          response_line.quantities.push(response_line_quantity);
        });
        response.lines.push(response_line);
      });
      return response;
    },
    getRfq: async function (id) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;
      rfqsApiInstance.rfqsIdGet(id, (error, data, response) => {
        if (error) {
          console.error(error);
          if (error == "login_required") {
            window.location.href = "/signin";
          }
          datadogLogs.logger.error("getRfq() failed", {
            rfqId: id,
            error: error,
          });
          this.$emit("onError", response, true);
        } else {
          this.rfq = data;
          this.rfq_response = this.createResponse(this.rfq);
          datadogLogs.logger.info("getRfq() succeeded", { rfqId: this.rfq.id });
          this.getAttachments(this.rfq.label);
        }
      });
    },
    postRfq: async function (id, rfq_response) {
      this.loading = true;
      let opts = {
        quoteResponse: rfq_response,
      };
      rfqsApiInstance.rfqsIdPost(id, opts, (error, data, response) => {
        if (error) {
          console.error(error);
          datadogLogs.logger.error("postRfq() failed", {
            rfqId: id,
            error: error,
          });

          this.$emit("onError", response);
          this.loading = false;
        } else {
          datadogLogs.logger.info("postRfq() succeeded", {
            rfqId: this.rfq.id,
          });
          // this.files.forEach((file) => {
          //   this.uploadFile(response.text, file);
          // });
          this.$router.push("/quotes/" + response.text);
        }
      });
    },
    exportRfq: async function () {
      this.showLoadingSpinner = true;
      const token = await this.getToken();
      let rfq_id = this.$route.params.id;
      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;
      rfqsApiInstance.getRfqExportById(rfq_id, (error, data, response) => {
        if (error) {
          this.showLoadingSpinner = false;
          console.error(error);
        } else {
          this.showLoadingSpinner = false;
          let byteArray = this.base64ToArrayBuffer(data);
          this.saveByteArray("RFQ" + rfq_id + ".pdf", byteArray);
          console.log(response);
        }
      });
    },
    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function () {
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if (instance.loading == false) {
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated) {
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        } else {
          instance.$watch("loading", (loading) => {
            if (loading == false && instance.isAuthenticated) {
              instance
                .getTokenSilently()
                .then((authToken) => {
                  resolve(authToken);
                })
                .catch((error) => {
                  if (error == "login_required") {
                    window.location.href = "/signin";
                  }
                  reject(error);
                });
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated) {
              window.location.href = "/signin";
            }
          });
        }
      });
    },
    onSubmit() {
      this.confirmation = true;
    },
    onConfirm() {
      let id = this.rfq.id;
      let rfq_response = this.rfq_response;
      this.postRfq(id, rfq_response);
    },
  },
  created() {
    let id = this.$route.params.id;
    this.getRfq(id);
  },
  mounted() {},
};
</script>
